import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import homeRouter from './modules/home.js';
import noLayout from './modules/noLayout.js';
import specialTopicRouter from './modules/specialTopic.js';
import customRouter from './modules/custom.js';
// export const constantRoutes = [homeRouter, specialTopicRouter, noLayout ];
// export const asyncRoutes = [homeRouter];
// 优先加载 customRouter（通过数组顺序控制优先级）
export const constantRoutes = [customRouter, homeRouter, specialTopicRouter, noLayout];
const createRouter = () =>
	new VueRouter({
		mode: 'history', // require service support
		scrollBehavior: () => ({ y: 0 }),
		routes: constantRoutes,
	});

const router = createRouter();
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	const newRouter = createRouter();
	router.matcher = newRouter.matcher; // reset router
}
export default router;
